const $$splitComponentImporter = () => import('/app/apps/webapp/src/app/routes/_public/login.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import * as z from 'zod';
const loginSearchSchema = z.object({
  next: z.string().optional().catch(undefined),
  reset: z.literal('success').optional().catch(undefined)
});
export const Route = createFileRoute('/_public/login')({
  validateSearch: loginSearchSchema,
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});